var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"active":_vm.open,"full-screen":"","trap-focus":"","destroy-on-hide":"","can-cancel":false}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }